import { m } from 'framer-motion';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'src/hooks/use-translation';

import { Link } from 'src/components/link';

import { ForbiddenIllustration } from 'src/assets/illustrations/forbidden-illustration';

import { varBounce, MotionContainer } from 'src/components/animate';
import { CompactLayout } from 'src/layouts/compact';
import { PATHS } from 'src/routes/paths';

// ----------------------------------------------------------------------

type Props = {
  standalone?: boolean;
};

export function ForbiddenView({ standalone = true }: Props) {
  const { t } = useTranslation('error', { keyPrefix: 'forbidden' });
  const [searchParams] = useSearchParams();
  const search = searchParams.toString();
  const homeUrl = search ? `${PATHS.root}?${search}` : PATHS.root;

  const content = (
    <MotionContainer data-testid="forbidden-view">
      <m.div variants={varBounce().in}>
        <Typography variant="h3" sx={{ mb: 2 }}>
          {t('title')}
        </Typography>
      </m.div>

      <m.div variants={varBounce().in}>
        <Typography sx={{ color: 'text.secondary' }}>{t('text')}</Typography>
      </m.div>

      <m.div variants={varBounce().in}>
        <ForbiddenIllustration
          sx={{
            height: 260,
            my: { xs: 5, sm: 10 },
          }}
        />
      </m.div>

      <Button color="primary" component={Link} to={homeUrl} size="large" variant="contained">
        {t('go-home')}
      </Button>
    </MotionContainer>
  );

  if (!standalone) {
    return (
      <Stack
        sx={{ alignItems: 'center', justifyContent: 'center', flexGrow: 1, textAlign: 'center' }}
      >
        {content}
      </Stack>
    );
  }

  return <CompactLayout>{content}</CompactLayout>;
}
